import { render, staticRenderFns } from "./AdminClinicsRoute.vue?vue&type=template&id=02f5a741"
import script from "./AdminClinicsRoute.vue?vue&type=script&lang=js"
export * from "./AdminClinicsRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports